const ContentPaperEdit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0892 10.9145L11.0013 16.0044L8.49976 16.5047L9.00007 14.0031L14.0906 8.91328C14.355 8.64838 14.7139 8.49951 15.0882 8.49951C15.4625 8.49951 15.8214 8.64838 16.0858 8.91328L16.0918 8.91862C16.6421 9.47056 16.6409 10.3641 16.0892 10.9145Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6.4958 14.5034H2.4933C1.94067 14.5034 1.49268 14.0554 1.49268 13.5028V2.49593C1.49268 1.9433 1.94067 1.4953 2.4933 1.4953H12.4996C13.0522 1.4953 13.5002 1.9433 13.5002 2.49593V6.99874"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M6.49585 4.49719H10.4983" stroke="currentColor" strokeWidth="1.5" />
    <path d="M4.49451 7.49902H10.4983" stroke="currentColor" strokeWidth="1.5" />
    <path d="M4.49451 10.5009H9.49763" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)

export default ContentPaperEdit
